import { Action } from 'redux';
import { Future, FUTURE } from 'src/modules/common/types/Future';
import { SAVE_PROJECT } from 'src/modules/save-project/SaveProjectAction';
import { chainReducers } from 'src/utils/chainReducers';

export type SaveProjectState = {
  readonly status: Future<void> | null;
};

const defaultState: SaveProjectState = {
  status: null,
};

export const saveProjectReducer = chainReducers(defaultState, [
  (state: SaveProjectState, action: Action): SaveProjectState => {
    if (SAVE_PROJECT.isPending(action)) {
      return { ...state, status: FUTURE.pending() };
    }
    if (SAVE_PROJECT.isSuccess(action)) {
      return { ...state, status: FUTURE.success(undefined) };
    }
    if (SAVE_PROJECT.isFailure(action)) {
      return { ...state, status: FUTURE.failure(action.data) };
    }

    return state;
  },
]);
